import './LinksFooter.scss';
import { Layout } from 'antd';
import React from 'react';
import { useAuthToken } from '@hooks';
import { When } from 'react-if';
import { ContactUsLink, LogoutLink, PrivacyPolicyLink, TermsOfServiceLink } from '@ui/links';

const { Footer } = Layout;

export const LinksFooter: React.FC = () => {
	const { isLoggedIn } = useAuthToken();

	return (
		<Footer className='links-footer'>
			<ul>
				<li>
					<PrivacyPolicyLink />
				</li>
				<li>
					<TermsOfServiceLink />
				</li>
				<li>
					<ContactUsLink />
				</li>
				<When condition={ isLoggedIn }>
					<li>
						<LogoutLink />
					</li>
				</When>
			</ul>
		</Footer>
	);
};
